import { push } from 'connected-react-router'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent, { mocked } from 'agent'

import {
  getDomainAveragePosition,
  getDomainOverview,
  getDomainPosition,
  getDomainSerpFeatureChart,
  getDomainTraffic,
  getDomainVisibility
} from './domain.sagas'

import * as actions from 'redux/actions/domainsList.actions'
import * as accountActions from 'redux/actions/account.actions'
import * as dashboardActions from 'redux/actions/dashboard.actions'
import appMode from 'helpers/getAppMode'
import { DeletedProject } from '_base/Processing'

function* loadDomainsSaga() {
  try {
    const body = appMode.preview ? yield call(mocked.Domains.get) : yield call(agent.Domains.all)
    yield put(actions.loadDomainsSuccess(body.data))
  } catch (error) {
    yield put(actions.loadDomainsFailure(error))
  }
}

function* loadSingleDomainFullySaga(domain, filters) {
  try {
    const [
      overview,
      visibilityChart,
      averageRankChart,
      trafficChart,
      serpFeatures,
      positionsChart
    ] = yield all([
      call(getDomainOverview, domain.id, filters),
      call(getDomainVisibility, domain.id, filters),
      call(getDomainAveragePosition, domain.id, filters),
      call(getDomainTraffic, domain.id, filters),
      call(getDomainSerpFeatureChart, domain.id, filters),
      call(getDomainPosition, domain.id, filters)
    ])

    return (domain = {
      ...domain,
      attributes: {
        ...domain.attributes,
        ...overview.attributes,
        averageRankChart: averageRankChart,
        serpFeatures: serpFeatures,
        visibilityChart: visibilityChart,
        trafficChart: trafficChart,
        positionsChart: positionsChart
      }
    })
  } catch (error) {
    yield put(actions.loadDomainsFullyFailure(error))
  }
}

function* loadDomainsFullySaga(params) {
  try {
    const { filters } = params.payload
    const body = yield call(agent.Domains.all)
    const editedDomains = yield all(
      body.data.map(domain => call(loadSingleDomainFullySaga, domain, filters))
    )

    yield put(actions.loadDomainsFullySuccess(editedDomains))
  } catch (error) {
    yield put(actions.loadDomainsFullyFailure(error))
  }
}

function* loadDomainOverviewSaga(params) {
  try {
    const { id } = params.payload
    const overview = yield call(getDomainOverview, id)
    yield put(actions.loadDomainOverviewSuccess(id, overview.attributes))
  } catch (error) {
    yield put(actions.loadDomainsFullyFailure(error))
  }
}

function* deleteDomainSaga(params) {
  const { domainId } = params.payload
  try {
    yield call(agent.Domains.del, domainId)
    yield put(actions.deleteDomainSuccess(domainId))

    yield put(push('/domains/'))
    yield call(DeletedProject)
    yield put(accountActions.getAccountData())
    yield put(actions.loadDomainsFully())
    yield put(dashboardActions.getDashboardData())
  } catch (error) {
    yield put(actions.deleteDomainFailure(domainId))
  }
}

function* editDomain(params) {
  const { domainId } = params.payload
  yield put(push(`/domains/${domainId}/edit/1`))
}

function* addKeywords(params) {
  const { domainId } = params.payload
  yield put(push(`/domains/${domainId}/edit/2`))
}

function* addCompetitors(params) {
  const { domainId } = params.payload
  yield put(push(`/domains/${domainId}/edit/3`))
}

export default function* domainsListSagas() {
  yield all([
    takeLatest(actions.loadDomains.type, loadDomainsSaga),
    takeLatest(actions.loadDomainsFully.type, loadDomainsFullySaga),
    takeLatest(actions.loadDomainOverview.type, loadDomainOverviewSaga),
    takeLatest(actions.deleteDomain.type, deleteDomainSaga),
    takeLatest(actions.editDomain.type, editDomain),
    takeLatest(actions.addKeywords.type, addKeywords),
    takeLatest(actions.addCompetitors.type, addCompetitors)
  ])
}
